import http from "@/services/http";

export const users = () => {
  async function list() {
    const {data} = await http.get('/users/list');
    return data;
  }

  async function store(item) {
    const response = await http.post('/users/store', item);
    return response.data;
  }

  async function delet(id) {
    await http.put('/users/delete/'+id, {});
    return true;
  }

  async function update(item) {
    const response = await http.post('/users/edit', item);
    return response.data;
  }

  async function getOne(id) {
    const {data} = await http.get('/users/getOne/'+id);
    return data;
  }

  return {list, store, delet, update,getOne};
}